  <nb-card style="margin-bottom:1rem !important;"  >
 		<nb-card-header>

		 <span class="panelToggler"   [class.unvisiblePanelLabel]="panelVisibility.isUnvisible('streamMoveFrom')"  (click)="panelVisibility.toggleVisibility('streamMoveFrom')" >Замінити запис з відео</span>    
           	</nb-card-header>
                <nb-card-body *ngIf="!panelVisibility.isUnvisible('streamMoveFrom')" [@visibilityPanelAnimation]>


			<div class="flex">

				<div class="flex" style="flex:1; margin-right:15px">
					<nb-select  [(selected)]="selectedVideo" [disabled]="loading"   fullWidth [placeholder]="stream.userVideos.length ? 'Виберіть відео' : 'Відео поки немає'">
					      <nb-option *ngFor="let item of stream.userVideos" [value]="item">{{item.title}}</nb-option>
					    </nb-select>


				</div>

				<div>
					<button  (click)="openDialog(moveModal)"  [disabled]="loading || !selectedVideo" [nbSpinner]="loading" nbButton status="primary">Замінити запис</button>

				</div>
			</div>

 

		</nb-card-body>

  </nb-card>












 <ng-template #moveModal  let-data   let-ref="dialogRef">

  <div style="max-width:400px">
         <nb-card>
      <nb-card-header>
  
    
    <div style="display:flex; width:100%">
      <span>Підтвердіть дію</span>   
       <span style="display:flex; margin-left:auto; cursor: pointer;"  (click)="ref.close()">
<nb-icon [icon]="'close-outline'" pack="eva"></nb-icon>
	</span>  
    </div>
  </nb-card-header>
      <nb-card-body>
    <div>
        
         
<p> Ця дія незворотно видалить поточний запис трансляції і замінить його записом з обраного відео. </p> <p> Ви впевнені що хочете продовжити?</p>     
  
    </div>
  </nb-card-body>
      <nb-card-footer>
       
         
    <div style="display:flex; width:100%">
            
            <button style="display:flex; margin-left:auto; cursor: pointer;" (click)="startProccess(ref)" nbButton status="danger" >Замінити запис</button>
            <button style="display:flex; margin-left:15px; cursor: pointer;" (click)="ref.close()" nbButton status="basic" >Скасувати</button>

  
          </div>
      </nb-card-footer>
    </nb-card>
     
  </div>
    </ng-template>





   <div *ngIf="loading" style="position: fixed; z-index: 7777; width:100%; height:100%; top:0; left: 0; background:rgba(0,0,0,0.5); display: flex; align-self: center;">

 <div style=" margin: auto;"> 
  
  	<div style="display:flex; "><div style="display:flex; margin:auto; color:#fff" ><app-loader></app-loader></div> </div>

	<p style="color:#fff">  <span>Йде завантаження. Не перезавантажуйте сторінку</span></p>
    </div>
    </div>

 
